import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FilterProductVariantsComponent } from "./filter-product-variants.component";
import { SelectModule } from "ng-select";

@NgModule({
  declarations: [FilterProductVariantsComponent],
  imports: [CommonModule, RouterModule, SelectModule, FormsModule],
  exports: [FilterProductVariantsComponent],
})
export class FilterProductVariantsModule {}



// WEBPACK FOOTER //
// /app/src/app/layout/filter-product-variants/filter-product-variants.module.ts